import React from 'react'
import styled from 'styled-components'
import { Colors, Fonts, FontWeights } from '../../../constants'
import { CurrencyValue } from '../../../model'
import { getDisplayDate, getDisplayValueWithSymbol } from '../../../utils'

interface Props {
  position: UserStakePosition
}

export type UserStakePosition = {
  endAt?: Date
  total: CurrencyValue
  claimable: CurrencyValue
  withdrawable: CurrencyValue
  withdrawn: boolean
}

export function StakePosition({ position }: Props) {
  return (
    <Container>
      <Position>
        <span>{getDisplayValueWithSymbol(position.total, 6)}</span>
        <span>
          Ends: {position.endAt ? getDisplayDate(position.endAt) : 'Ended'}
          {position.withdrawn && ' (Withdrawn)'}
        </span>
      </Position>
      <Claimable>{getDisplayValueWithSymbol(position.claimable, 3)}</Claimable>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  place-items: center;
`

const Position = styled.div`
  padding: 5px 0px;
  display: flex;
  flex-direction: column;
  color: ${Colors.LightererGray};
  font-size: 11px;
  font-family: ${Fonts.Body};
  font-weight: ${FontWeights.Regular};
  text-transform: uppercase;
  text-decoration: none;

  > span {
    padding: 5px 0px;
    display: block;
    text-align: left;
  }
`

const Claimable = styled.div`
  padding: 5px;
  color: ${Colors.LightererGray};
  font-size: 11px;
  font-family: ${Fonts.Body};
  font-weight: ${FontWeights.Regular};
  border: 1px solid ${Colors.DarkerGray};
  text-transform: uppercase;
  text-decoration: none;
`
